import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { i18nt } from '@/i18n';
import useViewModel from '../../../menu-items/viewmodels/list';

export const useGetTitle = () => {
  const [title, setTitle] = useState<string>('');
  const { pageData } = useViewModel();
  const { dataList } = pageData;

  const hanldeTittle = (path: string) => {
    if (path === 'menu-items') {
      setTitle('Menu Item');
    } else if (path === 'me') {
      setTitle(i18nt('common.profile'));
    } else if (path === 'change-password') {
      setTitle(i18nt('common.changePassword'));
    } else {
      if (dataList) {
        const dataTitle = dataList.find((i) => i?.url === path);
        if (dataTitle) {
          setTitle(dataTitle.name);
        }
      }
    }
  };

  // useEffect(() => {
  //   actionGetAll({ isActive: true });
  // }, []);

  return { title, setTitle, hanldeTittle };
};
